import React, {useContext} from "react";
import {FilterContext} from "../context/filterContext";
import SortIcon from '../../../assests/img/card-sort.svg?react';
import '../../../assests/css/cardsort.scss';

export default function CardSort() {

    const {filterContent, setFilterContent} = useContext(FilterContext);

    const handleSort = (order: number) => {
        setFilterContent({...filterContent, order: order});
    }

    return (
        <div className="card-sort-container">
            {filterContent.order === 0?
            <span onClick={()=> handleSort(1)}>
                <SortIcon/>
                {/* <span className="card-sort-text">
                    Ascending </span> */}
                {/* <span> <DropdownIcon/> </span> */}
            </span>:
            <span onClick={()=> handleSort(0)}>
                <SortIcon transform='rotate(180)'/>
                {/* <span className="card-sort-text">
                    Descending </span> */}
                {/* <span> <DropdownIcon/> </span> */}
            </span>}
        </div>
    )
}